/* AFORDA whole-rupee product-price presentation.
   Display only: never changes cart line-item or checkout amounts. */
(() => {
  if (window.afordaWholeRupeeDisplay) return;
  window.afordaWholeRupeeDisplay = true;
  const matchPrice = /(?:₹|Rs\.?\s*)(\s*)([\d,]+)\.(\d{1,2})(?!\d)/g;
  const targets = [
    '.aforda-pdp .price', '.aforda-pdp .aforda-price',
    '.product-card-wrapper .price', '.aforda-rec-card__prices',
    '.afw__price', '.afw__compare-price', '.afw__current-price',
    '.aforda-related__item .price', '.aforda-ed__products-grid .price',
    '.template-search .price', '.product__info-container .price'
  ].join(',');
  function normalizeText(node) {
    if (!node || !node.nodeValue || !/[₹]|Rs\.?/.test(node.nodeValue)) return;
    const updated = node.nodeValue.replace(matchPrice, (_all, space, whole, decimals) => {
      const amount = Math.round(Number(whole.replace(/,/g, '')) + Number('0.' + decimals));
      return '₹' + amount.toLocaleString('en-IN');
    });
    if (updated !== node.nodeValue) node.nodeValue = updated;
  }
  function normalize(root) {
    if (!root) return;
    const elements = [];
    if (root.nodeType === 1 && root.matches?.(targets)) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll(targets));
    for (const el of elements) {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(normalizeText);
    }
  }
  // Scan the page only once. Subsequent Shopify section / variant updates
  // normalize the changed price elements, not the entire document.
  const pending = new Set();
  let queued = false;
  function inPrice(node) {
    const element = node?.nodeType === 1 ? node : node?.parentElement;
    return element?.closest?.(targets) || null;
  }
  function schedule(root) {
    if (!root) return;
    pending.add(root);
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      const work = Array.from(pending);
      pending.clear();
      for (const element of work) {
        if (element === document || element.isConnected) normalize(element);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(document), {once:true});
  } else schedule(document);

  new MutationObserver((changes) => {
    for (const change of changes) {
      const host = inPrice(change.target);
      if (change.type === 'characterData') {
        if (host && /\.\d{1,2}(?!\d)/.test(change.target.nodeValue || '')) schedule(host);
        continue;
      }
      if (host) schedule(host);
      for (const node of change.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.(targets) || node.querySelector?.(targets))) schedule(node);
      }
    }
  }).observe(document.documentElement, {subtree:true, childList:true, characterData:true});
})();
